export async function openBillingPortal(store, { returnUrl = window.location.href, onError } = {}) {
  try {
    const response = await store.dispatch('payment/createBillingPortalSession', { returnUrl })

    if (response?.data?.url) {
      window.location.href = response.data.url
    } else {
      const message = 'Failed to create billing portal session'
      if (onError) onError(message)
    }
  } catch (error) {
    const message = error?.response?.data?.error || 'Failed to create billing portal session'
    if (onError) onError(message)
  }
}
